<template>
    <div class="message-item__evaluation">
        <div :class="[ 'evaluation', classname]">
            <div class="evaluation__item evaluation__up"
                @click="evaluate(VALUE.UP)">
                <i class="evaluation__icon icon_thumb-up"></i>
                <span>有用</span>
            </div>
            <div class="evaluation__item evaluation__down"
                @click="evaluate(VALUE.DOWN)">
                <i class="evaluation__icon icon_thumb-down"></i>
                <span>没用</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { getKeyByValue, inObjectValues } from '@/utils'
    import { postEvaluateMessage } from '@/api/chat'
    import { EVALUATE_MESSAGE } from '@/constants/pub_sub'

    const VALUE = {
        'UP': 1,
        'DOWN': -1,
        'NONE': 0
    }

    export default {
        name: 'MessageEvaluation',
        props: {
            messageId: {
                type: String,
                required: true
            },
            idFromServer: {
                type: String,
                required: true
            },
            value: {
                type: Number,
                required: true,
                validator (value) {
                    return inObjectValues(VALUE, value)
                }
            }
        },
        data () {
            return {
                VALUE,
                isRequesting: false
            }
        },
        computed: {
            classname () {
                const key = getKeyByValue(VALUE, this.value)
                if (key) {
                    return {
                        [`evaluation--${key.toLowerCase()}`]: true
                    }
                }
                return {}
            },
            isDisabled () {
                return this.value !== VALUE.NONE
            }
        },
        methods: {
            async evaluate (value) {
                if (this.isDisabled || this.isRequesting) {
                    return
                }
                this.isRequesting = true
                try {
                    await postEvaluateMessage(
                        this.$eventBus.uid,
                        this.$eventBus.entryKey,
                        this.$eventBus.chatSource,
                        this.idFromServer,
                        value === VALUE.UP
                    )
                    this.$eventBus.$emit(EVALUATE_MESSAGE, {
                        id: this.messageId,
                        value
                    })
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                } finally {
                    this.isRequesting = false
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .message-item {
        &__evaluation {
            position: absolute;
            right: 0;
            left: 0;
            top: 100%;
        }
    }

    .evaluation {
        width: 100%;
        height: 30px;
        padding-top: 8px;
        box-shadow: $primary-box-shadow;
        // border-top: 1px solid #E1E2E4;
        @include radius(0, 0, .5, .5);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &__icon {
            font-size: 15px;
            margin-right: 5px;
        }
        
        &__item {
            width: 47%;
            background: #fff;
            line-height: 30px;
            font-size: 12px;
            color: $primary-text-color;
            text-align: center;
            @include flex-center;
            cursor: pointer;
            @include radius(.9);
            @at-root .evaluation--none &:active {
                color: $primary-color;
            }

            &:last-child {
                border-left: 1px solid #E1E2E4;
            }

            & > span {
                user-select: none;
            }
        }

        // S 已评价
        &--up,
        &--down {
            pointer-events: none;
        }

        &--up {
            .evaluation__up {
                color: #1EF1C6;
            }
        }

        &--down {
            .evaluation__down {
                color: #1EF1C6;
            }
        }
        // E 已评价
    }

</style>
